import * as FlatModels from '@medsurf/flat-models';
import * as EntityBaseActions from '../base/entity.base.actions';

// <editor-fold desc="Action Types">

/**
 * Action Types
 */
export enum ActionTypes {
  /**
   * Store
   */
  GetEntitySuccess = '[STORE | ENTITY | ANNOTATION_GROUP] Get Entity Success',
  GetEntitiesSuccess = '[STORE | ENTITY | ANNOTATION_GROUP] Get Entities Success',
  ModifyEntitySuccess = '[STORE | ENTITY | ANNOTATION_GROUP] Modify Entity Success',
  ModifyEntitiesSuccess = '[STORE | ENTITY | ANNOTATION_GROUP] Modify Entities Success',
  AddEntity = '[STORE | ENTITY | ANNOTATION_GROUP] Add Entity',
  UpdateEntity = '[STORE | ENTITY | ANNOTATION_GROUP] Update Entity',
  RemoveEntity = '[STORE | ENTITY | ANNOTATION_GROUP] Remove Entity',
  UndoSnapshot = '[STORE | ENTITY | ANNOTATION_GROUP] Undo Snapshot',
  RedoSnapshot = '[STORE | ENTITY | ANNOTATION_GROUP] Redo Snapshot',
  CleanUpSnapshots = '[STORE | ENTITY | ANNOTATION_GROUP] Clean Up Snapshots',
  SetGroupId = '[STORE | ENTITY | ANNOTATION_GROUP] Set Group Id',
  SetAreaGroupId = '[STORE | ENTITY | ANNOTATION_GROUP] Set Area Group Id',
  RearrangeGroups = '[STORE | ENTITY | ANNOTATION_GROUP] Rearrange Groups',
  /**
   * Request
   */
}

// </editor-fold>

// <editor-fold desc="Models">

// </editor-fold>

// <editor-fold desc="Store">

/**
 * Get Entity Success
 */
export class GetEntitySuccess extends EntityBaseActions.GetEntitySuccess {
  public static readonly type = ActionTypes.GetEntitySuccess;
}

/**
 * Get Entities Success
 */
export class GetEntitiesSuccess extends EntityBaseActions.GetEntitiesSuccess {
  public static readonly type = ActionTypes.GetEntitiesSuccess;
}

/**
 * Modify Entity Success
 */
export class ModifyEntitySuccess extends EntityBaseActions.ModifyEntitySuccess {
  public static readonly type = ActionTypes.ModifyEntitySuccess;
}

/**
 * Modify Entities Success
 */
export class ModifyEntitiesSuccess extends EntityBaseActions.ModifyEntitiesSuccess {
  public static readonly type = ActionTypes.ModifyEntitiesSuccess;
}

/**
 * Add Entity
 */
export class AddEntity extends EntityBaseActions.AddEntity<FlatModels.GroupEntityModels.Group> {
  public static readonly type = ActionTypes.AddEntity;
}

/**
 * Update Entity
 */
export class UpdateEntity extends EntityBaseActions.UpdateEntity<FlatModels.GroupEntityModels.Group> {
  public static readonly type = ActionTypes.UpdateEntity;
}

/**
 * Remove Entity
 */
export class RemoveEntity extends EntityBaseActions.RemoveEntity<FlatModels.GroupEntityModels.Group> {
  public static readonly type = ActionTypes.RemoveEntity;
}

/**
 * Undo Snapshot
 */
export class UndoSnapshot extends EntityBaseActions.UndoSnapshot {
  public static readonly type = ActionTypes.UndoSnapshot;
}

/**
 * Redo Snapshot
 */
export class RedoSnapshot extends EntityBaseActions.RedoSnapshot {
  public static readonly type = ActionTypes.RedoSnapshot;
}

/**
 * Clean Up Snapshots
 */
export class CleanUpSnapshots extends EntityBaseActions.CleanUpSnapshots {
  public static readonly type = ActionTypes.CleanUpSnapshots;
}

/**
 * Set GroupId
 */
export class SetGroupId {
  public static readonly type = ActionTypes.SetGroupId;

  public constructor(public groupId: string | null) {
  }
}

/**
 * Set AreaGroupId
 */
export class SetAreaGroupId {
  public static readonly type = ActionTypes.SetAreaGroupId;

  public constructor(public areaGroupId: string | null) {
  }
}

/**
 * Rearrange Groups
 */
export class RearrangeGroups {
  public static readonly type = ActionTypes.RearrangeGroups;

  public constructor(public groups: FlatModels.GroupEntityModels.Group[] | string[]) {
  }
}

// </editor-fold>

// <editor-fold desc="Request">

// </editor-fold>